/* wg-chat-fix.js - Wade Greens

   PROBLEM
   Shopify Inbox injects its <shopify-chat> element INSIDE the theme's mobile
   menu drawer (div.halo-sidebar.halo-sidebar-left) instead of into <body>.
   Measured on the live site 2026-09-25:
     shopify-chat parent  = div.halo-sidebar.halo-sidebar-left
     position fixed, z-index 2147483000, x 378 (off-screen right of a 375 vw)
   Consequences:
     - the bubble is invisible on desktop and mobile, because its parent
       drawer is hidden until the hamburger is tapped
     - when the drawer IS open, the chat sits on top of the menu, because its
       z-index (2147483000) beats the drawer's (9999999)

   FIX
   Re-parent <shopify-chat> to <body> so it no longer depends on the drawer,
   and cap its z-index below the drawer so it can never cover the menu again.
   Inbox re-injects on navigation, so a MutationObserver keeps watch rather
   than running once.

   Z-INDEX LADDER (theme values, measured):
     halo-sidebar (mobile menu) 9999999
     wg chat cap                 9999   <- below the menu, above page content
*/
(function () {
  'use strict';

  var CAP = 9999;

  function fix() {
    var chat = document.querySelector('shopify-chat');
    if (!chat) return false;

    // 1. get it out of the mobile drawer
    if (chat.parentElement && chat.parentElement !== document.body) {
      document.body.appendChild(chat);
    }

    // 2. never let it sit above the open menu
    chat.style.setProperty('z-index', CAP, 'important');

    return true;
  }

  function start() {
    fix();
    var obs = new MutationObserver(function () { fix(); });
    obs.observe(document.body, { childList: true, subtree: false });

    // Inbox can mount late; stop polling once it is in place or after 15s
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      var chat = document.querySelector('shopify-chat');
      if ((chat && chat.parentElement === document.body) || tries > 30) {
        clearInterval(t);
      } else {
        fix();
      }
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();